/**
 * Sunday header: the cart count follows the cart, the festival greeting shows only when it fits,
 * and the language choice is shared with the
 * order portal (localStorage['sunday-lang']) before the store switches language.
 * Phone bars (below 600 px, mockup v105): scrolling down slides the header up and the bottom bar down; scrolling
 * up, the top of the page and its end bring both back. On selling pages the bottom bar also comes back 0.7 s
 * after scrolling stops; on reading pages (dock marked data-read) only on scroll up or at the end.
 */
document.addEventListener('sunday:cart', (e) => {
  const a = document.querySelector('[data-cart-link]');
  if (!a || !e.detail?.cart) return;
  const n = e.detail.cart.item_count;
  let em = a.querySelector('[data-cart-count]');
  if (!n) {
    em?.remove();
  } else {
    if (!em) {
      em = document.createElement('em');
      em.dataset.cartCount = '';
      a.append(em);
    }
    em.textContent = n;
    em.classList.remove('sd-bump');
    void em.offsetWidth;
    em.classList.add('sd-bump');
  }
  if (a.dataset.tpl) a.setAttribute('aria-label', a.dataset.tpl.replace('[n]', n));
});

/* Language: Shopify's language form switches the page to that language's address (/hi/, /ta/ …).
   The language on screen is also kept in localStorage['sunday-lang'], a backup for the order portal.
   Delegated, because the menu sheet's pills are cloned in later. */
const keepLang = (v, chosen) => {
  try {
    if (v) localStorage.setItem('sunday-lang', v);
    /* a language picked by hand: the one-time offer under the header never shows again */
    if (chosen) localStorage.setItem('sunday-lang-offer', 'chosen');
  } catch (e) {
    /* storage blocked: the store still switches */
  }
};
keepLang(document.documentElement.lang);
document.addEventListener('change', (e) => {
  const sel = e.target.closest && e.target.closest('select[data-sunday-lang]');
  if (!sel) return;
  keepLang(sel.value, true);
  sel.form.submit();
});
document.addEventListener('click', (e) => {
  const b = e.target.closest && e.target.closest('button[data-sunday-lang]');
  if (b) keepLang(b.value, true);
  /* the header's language pill (600–1099 px) closes on a tap outside it */
  document.querySelectorAll('details.sd-hlp[open]').forEach((d) => {
    if (!d.contains(e.target)) d.removeAttribute('open');
  });
});
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('details.sd-hlp[open]').forEach((d) => {
    d.removeAttribute('open');
    d.querySelector('summary').focus();
  });
});

/* Festival greeting beside the logo: shown only while it fits whole (never cut to "Happy Indep…").
   The inline check in sections/sunday-header.liquid did the first pass before the page was drawn;
   this keeps it right after fonts load and on resize. When it no longer fits, the page's own greeting
   slot (the home hero eyebrow) takes it, so it is still said once. */
/* Menu row from 720 to 1100 px: it scrolls sideways when it doesn't fit; fade the right edge while more is hidden. */
const dnav = document.querySelector('.sd-dnav');
if (dnav) {
  const more = () => dnav.classList.toggle('sd-navmore', dnav.scrollWidth - dnav.clientWidth - dnav.scrollLeft > 2);
  dnav.addEventListener('scroll', more, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(more).observe(dnav);
  addEventListener('load', more);
  more();
}

const festGreet = document.querySelector('.sd-festg[data-fest-on]');
if (festGreet) {
  const html = document.documentElement;
  const fit = () => {
    festGreet.classList.remove('sd-cut');
    /* Exact widths: scrollWidth rounds, so a word cut by 1px could still pass. */
    const r = document.createRange();
    r.selectNodeContents(festGreet);
    /* Once the page has said it (a filled greeting slot in <main>), the header stays quiet. */
    const said = !html.hasAttribute('data-festg') && document.querySelector('main [data-fest-slot="greeting"][data-fest-on]');
    const cut = !!said || r.getBoundingClientRect().width > festGreet.getBoundingClientRect().width + 0.1;
    festGreet.classList.toggle('sd-cut', cut);
    if (cut && html.hasAttribute('data-festg')) {
      html.removeAttribute('data-festg');
      window.SundayFest?.fill(document);
    }
    /* 22 Oct (AR): the greeting now fits beside the logo (fonts loaded, wider screen): say it there, once.
       The home hero's top line goes back to its own words. */
    if (!cut && !html.hasAttribute('data-festg')) {
      html.setAttribute('data-festg', '');
      document.querySelectorAll('main .sd-dh-eb[data-fest-on][data-fest-orig]').forEach((el) => {
        el.textContent = el.getAttribute('data-fest-orig');
        el.removeAttribute('data-fest-on');
      });
    }
  };
  fit();
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(festGreet.parentElement);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  addEventListener('load', fit);
}

/* ---------- phone bars step aside while scrolling down (below 600 px) ---------- */
{
  const html = document.documentElement;
  const phone = matchMedia('(max-width: 599px)');
  const dock = document.querySelector('.sd-dock');
  const read = !!(dock && dock.hasAttribute('data-read'));
  let last = scrollY;
  let idle = 0;
  const show = () => html.classList.remove('sd-hdhide', 'sd-dkhide');
  const busy = () => html.classList.contains('sd-hc-open') || !!document.querySelector('.sd-ov:not([hidden])') || !!document.activeElement?.matches?.('input, textarea, select');
  addEventListener(
    'scroll',
    () => {
      if (!phone.matches || busy()) return show();
      const y = scrollY;
      const d = y - last;
      const end = y + innerHeight >= document.documentElement.scrollHeight - 40;
      if (y < 80 || end) show();
      else if (d > 6) html.classList.add('sd-hdhide', 'sd-dkhide');
      else if (d < -6) show();
      if (Math.abs(d) > 6) last = y;
      clearTimeout(idle);
      if (!read) idle = setTimeout(() => html.classList.remove('sd-dkhide'), 700);
    },
    { passive: true }
  );
  phone.addEventListener('change', show);
}

/* Order journey (AR, 17 Oct): each page's short name (header data-sd-step, English) and language
   (data-sd-lang) are kept in this browser only, in localStorage['sunday-journey']; the cart page saves the
   line on the cart, so the team sees it on the order (Additional details → Journey). A reload of the same
   page within 30 minutes is not a new step. After an order a new cart starts the next line from the pages seen after that order. */
(() => {
  const h = document.querySelector('[data-sd-step]');
  if (!h || !h.dataset.sdStep) return;
  const KEY = 'sunday-journey';
  const tok = decodeURIComponent((document.cookie.match(/(?:^|; )cart=([^;]*)/) || [])[1] || '').split('?')[0];
  try {
    let j = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!j || !Array.isArray(j.s)) j = { s: [] };
    /* a new cart after a saved one: the pages up to that save belonged to the last order */
    if (j.sent && tok && j.sent !== tok) j = { s: j.s.filter((x) => x.t > (j.at || 0)) };
    const now = Date.now();
    const last = j.s[j.s.length - 1];
    if (last && last.p === h.dataset.sdStep && last.l === h.dataset.sdLang && now - last.t < 18e5) last.t = now;
    else j.s.push({ p: h.dataset.sdStep, l: h.dataset.sdLang, c: document.documentElement.lang, t: now });
    j.s = j.s.slice(-80);
    localStorage.setItem(KEY, JSON.stringify(j));
  } catch (e) {
    /* storage blocked: no journey line */
  }
})();

/* Indian-script pages keep the English line count where English has one line (AR, 17 Oct):
   - a headline printed sentence by sentence (span.sd-nb, snippets/sunday-sentences) keeps each sentence on one line;
   - one-line words (product name, the cart's Checkout, compare-table feel, Remove, Mattresses card names on a phone, the
     sticky bar's size, the home rating line, home tile names from 960 px) stay on one line.
   When the words are wider than their box, their type steps down just enough (never below 70% for a headline,
   80% for the rest; words that would still wrap at 80% keep their size and wrap as before). Runs when fonts load, on resize and when the
   festival engine fills the headline. English pages are left alone. */
if (!/^en/.test(document.documentElement.lang)) {
  const ONE = ['.sd-mh-h1', '.sd-cpay > span', '.sd-bct-fe > b', '.sd-row > .sd-lnk', '.sd-mbar-chip > span', '.sd-dh-rate > em', '.sd-mbar-add', '.sd-mh-fm', '.sd-ttp', '.sd-apbar-p', '.sd-a2bar-t', '.sd-mfl-cue'];
  const ONE_PHONE = ['.sd-mx-chip > b', '.sd-mx-band > small', '.sd-mx-fm > span', '.sd-mx-pr > .sd-num']; /* Mattresses phone bar names; card tag, feel and From price (24 Oct) */
  const ONE_WIDE = ['.sd-mtile h3'];
  /* width of the words on one line, and the room for them inside the element (padding left out) */
  const natural = (el) => {
    el.style.setProperty('white-space', 'nowrap', 'important');
    const g = document.createRange();
    g.selectNodeContents(el);
    const w = g.getBoundingClientRect().width;
    el.style.removeProperty('white-space');
    return w;
  };
  const room = (el) => {
    const cs = getComputedStyle(el);
    const pad = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    return (el.clientWidth || el.getBoundingClientRect().width) - (el.clientWidth ? pad : 0);
  };
  const shrink = (el, box, need, min, all) => {
    if (!box || need <= box + 0.5) return;
    /* words that would still wrap at the smallest size keep their size and wrap, as before */
    if (!all && (box - 1) / need < min) return;
    const fs = parseFloat(getComputedStyle(el).fontSize);
    el.style.setProperty('font-size', Math.max(fs * min, Math.floor((fs * (box - 1)) / need * 10) / 10) + 'px');
  };
  const fitNb = () => {
    /* 21 Oct (older phones): no :has() in a selector (it throws on Chrome < 105 and stops this script) */
    for (const h of [...document.querySelectorAll('h1, h2')].filter((x) => x.querySelector(':scope > .sd-nb'))) {
      h.style.removeProperty('font-size');
      let widest = 0;
      for (const s of h.querySelectorAll(':scope > .sd-nb')) {
        s.style.setProperty('white-space', 'nowrap', 'important');
        widest = Math.max(widest, s.getBoundingClientRect().width);
        s.style.removeProperty('white-space');
      }
      shrink(h, h.clientWidth, widest, 0.7, true);
    }
    const sel = ONE.concat(innerWidth < 720 ? ONE_PHONE : [], innerWidth >= 960 ? ONE_WIDE : []).join(', ');
    document.querySelectorAll(ONE.concat(ONE_PHONE, ONE_WIDE).join(', ')).forEach((el) => el.style.removeProperty('font-size'));
    const phoneSel = ONE_PHONE.join(', ');
    for (const el of document.querySelectorAll(sel)) {
      if (!el.getClientRects().length) continue;
      /* the three narrow cards on a phone may step down to 75% (24 Oct: Malayalam feel line needed 78%) */
      shrink(el, room(el), natural(el), innerWidth < 720 && el.matches(phoneSel) ? 0.75 : 0.8);
    }
  };
  let fitT;
  const fitSoon = () => { clearTimeout(fitT); fitT = setTimeout(fitNb, 150); };
  fitNb();
  document.fonts?.ready.then(fitNb);
  addEventListener('resize', fitSoon, { passive: true });
  /* parts drawn or refilled later by their own scripts (festival headline, sticky bar, topper, cart) */
  new MutationObserver(fitSoon).observe(document.body, { childList: true, subtree: true, characterData: true });
}

/* Language pages: links typed as "/pages/…" in settings get the language in front ("/hi/pages/…"), so a visitor stays in their language. */
{
  const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  if (root) {
    const skip = /^\/(cdn|apps|checkout|account|services|tools)\b/;
    const fix = (a) => {
      const h = a.getAttribute('href');
      if (!h || h[0] !== '/' || h[1] === '/' || h === root || h.startsWith(root + '/') || h.startsWith(root + '?') || h.startsWith(root + '#') || skip.test(h)) return;
      a.setAttribute('href', root + h);
    };
    const all = (n) => n.querySelectorAll?.('a[href^="/"]').forEach(fix);
    all(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) { if (n.matches('a[href^="/"]')) fix(n); all(n); } }))).observe(document.body, { childList: true, subtree: true });
  }
}
